import { NavLink, Outlet } from "react-router-dom";

function navClass(isActive: boolean): string {
  return `lesson-ws-tab${isActive ? " is-active" : ""}`;
}

export default function AdminLayout() {
  return (
    <main className="page page-align-start">
      <header className="card card-wide admin-console-header">
        <p className="eyebrow">Admin console</p>
        <nav className="lesson-ws-tabs admin-console-tabs" aria-label="Admin sections">
          <NavLink to="/admin" end className={({ isActive }) => navClass(isActive)}>
            Overview
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => navClass(isActive)}>
            Users
          </NavLink>
          <NavLink to="/admin/community" className={({ isActive }) => navClass(isActive)}>
            Submissions
          </NavLink>
          <NavLink to="/admin/standards" className={({ isActive }) => navClass(isActive)}>
            Standards
          </NavLink>
        </nav>
      </header>
      <Outlet />
    </main>
  );
}
